import { attr, Constructable, ElementStyles, FASTElement } from '@microsoft/fast-element';
import { designTokens } from '../design-tokens';
import { DI, inject, Registration } from '@microsoft/fast-element/di.js';
import { PropertyStyleSheetBehavior } from '../foundation/property-stylesheet-behavior';

export const mediaSizes = ['extra-small', 'small', 'medium', 'large', 'extra-large'] as const;
export type MediaSize = typeof mediaSizes[number];

const container = DI.getOrCreateDOMContainer();

container.register(Registration.instance('mediaSizeObserver',
    new ResizeObserver((entries) => {
        for(const entry of entries) {
            if(entry.borderBoxSize) {
                var width = entry.borderBoxSize[0].inlineSize;

                if(width > designTokens['space-breakpoint-extra-large'].getValueFor(entry.target as FASTElement))
                    entry.target.setAttribute('media-size', 'extra-large');
                else if (width > designTokens['space-breakpoint-large'].getValueFor(entry.target as FASTElement))
                    entry.target.setAttribute('media-size', 'large');
                else if (width > designTokens['space-breakpoint-medium'].getValueFor(entry.target as FASTElement))
                    entry.target.setAttribute('media-size', 'medium');
                else if (width > designTokens['space-breakpoint-small'].getValueFor(entry.target as FASTElement))
                    entry.target.setAttribute('media-size', 'small');
                else
                    entry.target.setAttribute('media-size', 'extra-small');
            }
        }
    })
));

export function mediaSizeBehavior(value: string, styles: ElementStyles) {
    return new PropertyStyleSheetBehavior('mediaSize', value, styles);
}

export function MediaSizeMixin<TBase extends Constructable<FASTElement>>(Base: TBase) {
    class mediaSizeMixin extends Base {
        @inject('mediaSizeObserver')
        protected mediaSizeObserver!: ResizeObserver;

        /** A readonly attribute which reflects the closest breakpoint size of this container. */
        @attr({ attribute: 'media-size' })
        mediaSize: MediaSize;

        connectedCallback() {
            super.connectedCallback();
            this.mediaSizeObserver.observe(this);
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            this.mediaSizeObserver.unobserve(this);
        }
    }

    return mediaSizeMixin;
}
